import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service'
@Component({
  selector: 'app-message',
  templateUrl: './app-message.component.html',
  styleUrls: ['./app-message.component.scss']
})
export class AppMessageComponent implements OnInit {

  public type: any;
  constructor(
    public route: RoutingService
  ) { }

  ngOnInit(): void {
  }

}
